import React from 'react'

import Party from '../../models/Party'

import './PartyLozenge.scss'
import Utilities from '../../utils/Utilities'

interface IProps {
  className?: string
  party: Party
  muted?: boolean
  darkBg?: boolean
  small?: boolean
}

class PartyLozenge extends React.Component<IProps> {
  public render(): JSX.Element {
    const { className, darkBg, muted, party, small } = this.props

    const darkBgModifier = darkBg ? '-light' : ''

    const colorClass = muted
      ? `${darkBg ? '' : `party-${party.key}${darkBgModifier}`}`
      : `party-${party.key}-bg${darkBgModifier}`

    return (
      <div
        className={`
        PartyLozenge
        font-weight-bold
        ${className}
        ${colorClass}
        ${Utilities.classIf(darkBg, ' Dark')}
        party-${party.key}-border${darkBgModifier}
        ${Utilities.classIf(small, ' Small')}
        `}
      >
        {party.code}
      </div>
    )
  }
}

export default PartyLozenge
